import { Form, Select } from 'antd'
import ChangeStatus from './ChangeStatus'
import { useEffect } from 'react'

const actions = [
  {
    label: 'Mudar Estado',
    value: 'CHANGE_STATUS',
  },
  {
    label: 'Gerar Resumo',
    value: 'SUMMARIZE',
  },
]

export default function ChatIntegrationForm({ form, fieldName, parameters }) {
  const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)

  useEffect(() => {
    form.setFieldValue([fieldName, 'action'], {})
  }, [type, form, fieldName])

  return (
    <>
      <Form.Item label={'Tipo de ação'} name={[fieldName, 'action', 'type']}>
        <Select options={actions} placeholder={'Selecione o tipo de ação'} />
      </Form.Item>
      {type === 'CHANGE_STATUS' && <ChangeStatus fieldName={fieldName} form={form} parameters={parameters} />}
    </>
  )
}
